import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export default function FileUpload(props) {
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState(""); // 상태 추가
  const { t } = useTranslation();

  useEffect(() => {
    // 넘어온 파일 정보가 있으면 fileName을 업데이트
    if (props.defaultFileName) {
      // console.log("defaultFileName", props.defaultFileName);
      setFileName(props.defaultFileName);
    }
  }, [props.defaultFileName]);

  const handleUpload = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile.name); // 선택한 파일 이름으로 업데이트

    const url = "/api/file";
    const formData = new FormData();
    formData.append("file", selectedFile);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axios
      .post(url, formData, config)
      .then((res) => {
        const uploadedFiles = Array.isArray(res.data?.data)
          ? res.data.data
          : Array.isArray(res.data)
          ? res.data
          : [];
        props.handleUploadFile(props.category, uploadedFiles);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleClick = (id) => {
    if (id) {
      props.handleClick(id);
    }
  }

  return (
    <FileBox>
      <input
        className={props.className}
        type="text"
        value={fileName || t('key417')}
        placeholder={t("key417")}
        readOnly
        style={{
          cursor: fileName ? "pointer" : "not-allowed",
        }}
        onClick={() => handleClick(props.fileId)}
      />
      <label htmlFor={props.category}>{t('key418')}</label>
      <input
        id={props.category}
        type="file"
        onChange={handleUpload}
        accept={props.accept}
      />
    </FileBox>
  );
}

const FileBox = styled.div`
  display: inline-block;
  vertical-align: middle;

  input[type="text"] {
    text-align: left;
    height: auto;
    padding: 10px 12px;
    background: transparent;
    color: #a9a9a9;
  }
  input[type="file"] {
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;
    overflow: hidden;
    border: none;
    opacity: 0;
  }
  label {
    display: inline-block;
    width: 120px;
    padding: 10px 0;
    text-align: center;
    background-color: var(--primary-500);
    border: none;
    color: var(--grey-900);
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    margin-left: 12px;
    cursor: pointer;
  }
`;
